import React, { useState } from "react";
import { useAuth } from "@/contexts/AuthContext";
import { Button } from "@/components/ui/button";
import { Smartphone } from "lucide-react";
import UnauthorizedPlanModal from "./UnauthorizedPlanModal";
import { NequiPaymentModal } from "./payments/NequiPaymentModal";
import { cn } from "@/lib/utils";
import { IS_NEQUI_ENABLED } from "@/lib/config/featureFlags";

interface NequiButtonProps {
  amount: number;
  planId: string;
  planName: string;
  buttonText?: string;
  className?: string;
  onSuccess?: () => void;
}

const NequiButton: React.FC<NequiButtonProps> = ({
  amount,
  planId,
  planName,
  buttonText = "Pagar con Nequi",
  className,
  onSuccess,
}) => {
  if (!IS_NEQUI_ENABLED) return null;

  const { user } = useAuth();
  const [showUnauthorizedModal, setShowUnauthorizedModal] = useState(false);
  const [showNequiModal, setShowNequiModal] = useState(false);

  const handleClick = () => {
    if (!user) {
      setShowUnauthorizedModal(true);
      return;
    }
    setShowNequiModal(true);
  };

  return (
    <>
      <Button
        onClick={handleClick}
        className={cn(
          "w-full rounded-xl bg-[#200020] font-bold text-white shadow-md shadow-purple-900/20 transition-all hover:bg-[#2b0d2b] active:scale-[0.98] flex items-center justify-center gap-2 border border-[#DA0081]/30",
          className
        )}
      >
        <Smartphone className="h-5 w-5 text-[#DA0081]" />
        <span>{buttonText}</span>
      </Button>

      <NequiPaymentModal
        isOpen={showNequiModal}
        onClose={() => setShowNequiModal(false)}
        planId={planId}
        planName={planName}
        amount={amount}
        onSuccess={onSuccess}
      />

      <UnauthorizedPlanModal
        isOpen={showUnauthorizedModal}
        onClose={() => setShowUnauthorizedModal(false)}
        planName={planName}
        planPrice={amount}
      />
    </>
  );
};

export default NequiButton;
